<nouislider [config]="config" [ngModel]="sliderModel" (change)="sliderModel = $event" [disabled]="isDisabled" #slider></nouislider>
